export default "__VITE_ASSET__DQtxnTd4__"